import React from "react";
import {Container, IContainerProps} from "./Container";
import {Colors} from "../colors";

export const Card = ({children, row, onClick, className = "Card", sx}: IContainerProps) => {
  return (
    <Container
      className={className}
      fullWidth
      row={row}
      onClick={onClick}
      sx={{
        backgroundColor: Colors.bw.white,
        boxShadow: "none",
        border: `1px solid ${Colors.grey._200}`,
        borderRadius: "10px",
        padding: "25px 50px",
        ...sx,
      }}
    >
      {children}
    </Container>
  );
};
